export const BIC = 'SXPYDKKK';